import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { AssignmentScreen } from '../screens/assignment/AssignmentScreen';
import { VehicleSwapSelectionScreen } from '../screens/assignment/VehicleSwapSelectionScreen';
import { VehicleSwapScreen } from '../screens/assignment/VehicleSwapScreen';
import { VehicleAssignmentScreen } from '../screens/assignment/VehicleAssignmentScreenNew';
import ManageAssignmentScreen from '../screens/assignment/ManageAssignmentScreen';
import EditAssignmentScreen from '../screens/assignment/EditAssignmentScreen';
import { AssignmentHistory } from '../types';

const Stack = createStackNavigator();

export type AssignmentStackParamList = {
  AssignmentMain: { 
    onNavigateToHistory?: () => void;
    mode?: 'receiving';
    preSelectedVehicleId?: string;
    preSelectedDriverId?: string;
    preSelectedFormType?: 'delivery' | 'receiving' | 'swap';
    assignmentData?: {
      assignmentId: string;
      vehicleId: string;
      driverId: string;
      secondaryDriverId?: string;
      isSharedAssignment: boolean;
    };
  };
  VehicleSwapSelection: undefined;
  VehicleSwap: {
    currentVehicleId: string;
    newVehicleId: string;
  };
  VehicleAssignment: {
    vehicleId?: string;
    driverId?: string;
    mode?: 'assign' | 'unassign';
  };
  ManageAssignment: {
    assignment: AssignmentHistory;
  };
  EditAssignment: {
    assignment: AssignmentHistory;
  };
};

export const AssignmentNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false, // Disable all headers since we have custom header
      }}
    >
      <Stack.Screen 
        name="AssignmentMain" 
        component={AssignmentScreen}
        initialParams={{}}
      />
      <Stack.Screen
        name="VehicleSwapSelection"
        component={VehicleSwapSelectionScreen}
        options={{
          gestureEnabled: true,
          gestureDirection: 'horizontal',
        }}
      />
      <Stack.Screen
        name="VehicleSwap"
        component={VehicleSwapScreen}
        options={{
          gestureEnabled: false, // Disable swipe back to prevent accidental navigation
        }}
      />
      <Stack.Screen
        name="VehicleAssignment"
        component={VehicleAssignmentScreen}
        options={{
          gestureEnabled: true,
          gestureDirection: 'horizontal',
        }}
      />
      <Stack.Screen
        name="ManageAssignment"
        component={ManageAssignmentScreen}
        options={{
          gestureEnabled: true,
          gestureDirection: 'horizontal',
        }}
      />
      <Stack.Screen
        name="EditAssignment"
        component={EditAssignmentScreen}
        options={{
          gestureEnabled: true,
          gestureDirection: 'horizontal',
        }}
      />
    </Stack.Navigator>
  );
};